import { createNotifiedThunk } from '../reducers/createAppAsyncThunk';
import ContactService from '../services/ContactService';

const NAME = 'CONTACT';

const sendRequest = createNotifiedThunk(
    `${NAME}/sendRequest`,
    ContactService.sendRequest,
    { error: 'nepodarilo se odeslat zpravu' },
);

const ContactActions = {
    sendRequest,
};

export default ContactActions;
